export default {
    "name": "SalesOrder",
    "kind": "HoudiniQuery",
    "hash": "12bc3d54b04c9800b02c6aa88bf7e4123c5cdaafcc24e8b31646c2558f805968",

    "raw": `query SalesOrder($key: SalesOrderKey!, $messageFilter: MessageFilter, $pagination: PaginationOptions) {
  salesOrder(key: $key) {
    id
    adjustmentTotal
    allowBackorder
    allowPartialShipment
    appliedPaymentTotal
    balance
    creditMethod
    date
    dateEntered
    dateFinalized
    dateModified
    documentType {
      id
      name
    }
    expirationDate
    externalComments
    internalComments
    finalized
    paid
    purchaseOrderNumber
    salesOrderId
    sequentialId
    shippingTrackingNumber
    subtotal
    tax
    total
    truckNumber
    void
    lines(pagination: $pagination) {
      items {
        id
        lookup
        description
        cost
        hold
        price
        quantity
        taxable
        total
        type
        coreStatus
        backorderQuantity
        lostSaleQuantity
        quantityPicked
        quantityRequested
        quantityReturned
        manufacturer {
          id
          code
          name
        }
        inventory {
          id
          inventoryId
          quantity
          quantityAvailable
          quantityOnHold
          quantityOnOrder
          partNumber
          partNumberStripped
          taxable
          messages(filter: $messageFilter) {
            id
            text
            type
            trigger
            important
          }
          inventoryType {
            id
            messages(filter: $messageFilter) {
              id
              type
              text
              trigger
              important
            }
          }
          locations {
            location {
              name
              id
            }
            id
          }
          store {
            code
            id
          }
        }
        locations {
          location {
            ... on VirtualLocation {
              name
            }
            ... on Location {
              name
              id
            }
            __typename
          }
          id
        }
        vehicle {
          stockNumber
          taxable
          id
        }
      }
    }
    attachments {
      id
      public
      rank
      file {
        id
        created
        extension
        mimetype
        name
        hash
        type
        updated
        path
        size
        host
        url
      }
    }
    adjustments {
      id
      adjustmentType {
        id
        name
        code
      }
      amount
      date
      description
      subtotalAdjustment
      taxable
      void
    }
    appliedPaymentLines {
      id
      amount
      payment {
        id
        comments
        date
        dateEntered
        documentNumber
        paymentMethod {
          name
          id
        }
        store {
          name
          id
        }
        storeId
        void
        createdBy {
          name
          id
        }
      }
    }
    customer {
      id
      companyName
      balance
      accountLimit
      addresses {
        id
        label
      }
      messages(filter: $messageFilter) {
        id
        text
        type
        trigger
        important
      }
    }
    billingAddress {
      address1
      city
      country
      state
      zip
      company
      contact
      phone
    }
    shippingAddress {
      address1
      city
      company
      contact
      state
      zip
      country
      phone
    }
    shippingMethod {
      id
    }
    salesperson {
      id
      name
    }
    taxItem {
      id
      name
    }
    term {
      id
      name
      chargeDays
      chargeDayOfMonth
    }
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "salesOrder": {
                "type": "SalesOrder",
                "keyRaw": "salesOrder(key: $key)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "id": {
                            "type": "ID",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "adjustmentTotal": {
                            "type": "Decimal2",
                            "keyRaw": "adjustmentTotal",
                            "visible": true
                        },

                        "allowBackorder": {
                            "type": "Boolean",
                            "keyRaw": "allowBackorder",
                            "visible": true
                        },

                        "allowPartialShipment": {
                            "type": "Boolean",
                            "keyRaw": "allowPartialShipment",
                            "visible": true
                        },

                        "appliedPaymentTotal": {
                            "type": "Decimal2",
                            "keyRaw": "appliedPaymentTotal",
                            "visible": true
                        },

                        "balance": {
                            "type": "Decimal2",
                            "keyRaw": "balance",
                            "visible": true
                        },

                        "creditMethod": {
                            "type": "SalesOrderCreditMethod",
                            "keyRaw": "creditMethod",
                            "visible": true
                        },

                        "date": {
                            "type": "Date",
                            "keyRaw": "date",
                            "visible": true
                        },

                        "dateEntered": {
                            "type": "DateTime",
                            "keyRaw": "dateEntered",
                            "visible": true
                        },

                        "dateFinalized": {
                            "type": "DateTime",
                            "keyRaw": "dateFinalized",
                            "nullable": true,
                            "visible": true
                        },

                        "dateModified": {
                            "type": "DateTime",
                            "keyRaw": "dateModified",
                            "visible": true
                        },

                        "documentType": {
                            "type": "SalesOrderDocument",
                            "keyRaw": "documentType",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "expirationDate": {
                            "type": "Date",
                            "keyRaw": "expirationDate",
                            "nullable": true,
                            "visible": true
                        },

                        "externalComments": {
                            "type": "String",
                            "keyRaw": "externalComments",
                            "visible": true
                        },

                        "internalComments": {
                            "type": "String",
                            "keyRaw": "internalComments",
                            "visible": true
                        },

                        "finalized": {
                            "type": "Boolean",
                            "keyRaw": "finalized",
                            "visible": true
                        },

                        "paid": {
                            "type": "Decimal2",
                            "keyRaw": "paid",
                            "visible": true
                        },

                        "purchaseOrderNumber": {
                            "type": "String",
                            "keyRaw": "purchaseOrderNumber",
                            "visible": true
                        },

                        "salesOrderId": {
                            "type": "UInt",
                            "keyRaw": "salesOrderId",
                            "visible": true
                        },

                        "sequentialId": {
                            "type": "UInt",
                            "keyRaw": "sequentialId",
                            "nullable": true,
                            "visible": true
                        },

                        "shippingTrackingNumber": {
                            "type": "String",
                            "keyRaw": "shippingTrackingNumber",
                            "visible": true
                        },

                        "subtotal": {
                            "type": "Decimal2",
                            "keyRaw": "subtotal",
                            "visible": true
                        },

                        "tax": {
                            "type": "Decimal2",
                            "keyRaw": "tax",
                            "visible": true
                        },

                        "total": {
                            "type": "Decimal2",
                            "keyRaw": "total",
                            "visible": true
                        },

                        "truckNumber": {
                            "type": "String",
                            "keyRaw": "truckNumber",
                            "nullable": true,
                            "visible": true
                        },

                        "void": {
                            "type": "Boolean",
                            "keyRaw": "void",
                            "visible": true
                        },

                        "lines": {
                            "type": "SalesOrderLineList",
                            "keyRaw": "lines(pagination: $pagination)",

                            "selection": {
                                "fields": {
                                    "items": {
                                        "type": "SalesOrderLine",
                                        "keyRaw": "items",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "lookup": {
                                                    "type": "String",
                                                    "keyRaw": "lookup",
                                                    "visible": true
                                                },

                                                "description": {
                                                    "type": "String",
                                                    "keyRaw": "description",
                                                    "visible": true
                                                },

                                                "cost": {
                                                    "type": "Decimal2",
                                                    "keyRaw": "cost",
                                                    "visible": true
                                                },

                                                "hold": {
                                                    "type": "Boolean",
                                                    "keyRaw": "hold",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "price": {
                                                    "type": "Decimal2",
                                                    "keyRaw": "price",
                                                    "visible": true
                                                },

                                                "quantity": {
                                                    "type": "Decimal6",
                                                    "keyRaw": "quantity",
                                                    "visible": true
                                                },

                                                "taxable": {
                                                    "type": "Boolean",
                                                    "keyRaw": "taxable",
                                                    "visible": true
                                                },

                                                "total": {
                                                    "type": "Decimal2",
                                                    "keyRaw": "total",
                                                    "visible": true
                                                },

                                                "type": {
                                                    "type": "SalesOrderLineType",
                                                    "keyRaw": "type",
                                                    "visible": true
                                                },

                                                "coreStatus": {
                                                    "type": "CoreStatusEnum",
                                                    "keyRaw": "coreStatus",
                                                    "visible": true
                                                },

                                                "backorderQuantity": {
                                                    "type": "Decimal6",
                                                    "keyRaw": "backorderQuantity",
                                                    "visible": true
                                                },

                                                "lostSaleQuantity": {
                                                    "type": "Decimal6",
                                                    "keyRaw": "lostSaleQuantity",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "quantityPicked": {
                                                    "type": "Decimal6",
                                                    "keyRaw": "quantityPicked",
                                                    "visible": true
                                                },

                                                "quantityRequested": {
                                                    "type": "UInt",
                                                    "keyRaw": "quantityRequested",
                                                    "visible": true
                                                },

                                                "quantityReturned": {
                                                    "type": "Decimal6",
                                                    "keyRaw": "quantityReturned",
                                                    "visible": true
                                                },

                                                "manufacturer": {
                                                    "type": "Manufacturer",
                                                    "keyRaw": "manufacturer",
                                                    "nullable": true,

                                                    "selection": {
                                                        "fields": {
                                                            "id": {
                                                                "type": "UInt",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            },

                                                            "code": {
                                                                "type": "String",
                                                                "keyRaw": "code",
                                                                "visible": true
                                                            },

                                                            "name": {
                                                                "type": "String",
                                                                "keyRaw": "name",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "inventory": {
                                                    "type": "Inventory",
                                                    "keyRaw": "inventory",
                                                    "nullable": true,

                                                    "selection": {
                                                        "fields": {
                                                            "id": {
                                                                "type": "UInt",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            },

                                                            "inventoryId": {
                                                                "type": "Int",
                                                                "keyRaw": "inventoryId",
                                                                "visible": true
                                                            },

                                                            "quantity": {
                                                                "type": "Decimal6",
                                                                "keyRaw": "quantity",
                                                                "visible": true
                                                            },

                                                            "quantityAvailable": {
                                                                "type": "Decimal6",
                                                                "keyRaw": "quantityAvailable",
                                                                "visible": true
                                                            },

                                                            "quantityOnHold": {
                                                                "type": "Decimal6",
                                                                "keyRaw": "quantityOnHold",
                                                                "visible": true
                                                            },

                                                            "quantityOnOrder": {
                                                                "type": "Decimal6",
                                                                "keyRaw": "quantityOnOrder",
                                                                "visible": true
                                                            },

                                                            "partNumber": {
                                                                "type": "String",
                                                                "keyRaw": "partNumber",
                                                                "visible": true
                                                            },

                                                            "partNumberStripped": {
                                                                "type": "String",
                                                                "keyRaw": "partNumberStripped",
                                                                "visible": true
                                                            },

                                                            "taxable": {
                                                                "type": "Boolean",
                                                                "keyRaw": "taxable",
                                                                "visible": true
                                                            },

                                                            "messages": {
                                                                "type": "Message",
                                                                "keyRaw": "messages(filter: $messageFilter)",

                                                                "selection": {
                                                                    "fields": {
                                                                        "id": {
                                                                            "type": "UInt",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        },

                                                                        "text": {
                                                                            "type": "String",
                                                                            "keyRaw": "text",
                                                                            "nullable": true,
                                                                            "visible": true
                                                                        },

                                                                        "type": {
                                                                            "type": "MessageType",
                                                                            "keyRaw": "type",
                                                                            "visible": true
                                                                        },

                                                                        "trigger": {
                                                                            "type": "MessageTrigger",
                                                                            "keyRaw": "trigger",
                                                                            "visible": true
                                                                        },

                                                                        "important": {
                                                                            "type": "Boolean",
                                                                            "keyRaw": "important",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            },

                                                            "inventoryType": {
                                                                "type": "InventoryType",
                                                                "keyRaw": "inventoryType",

                                                                "selection": {
                                                                    "fields": {
                                                                        "id": {
                                                                            "type": "UInt",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        },

                                                                        "messages": {
                                                                            "type": "Message",
                                                                            "keyRaw": "messages(filter: $messageFilter)",

                                                                            "selection": {
                                                                                "fields": {
                                                                                    "id": {
                                                                                        "type": "UInt",
                                                                                        "keyRaw": "id",
                                                                                        "visible": true
                                                                                    },

                                                                                    "type": {
                                                                                        "type": "MessageType",
                                                                                        "keyRaw": "type",
                                                                                        "visible": true
                                                                                    },

                                                                                    "text": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "text",
                                                                                        "nullable": true,
                                                                                        "visible": true
                                                                                    },

                                                                                    "trigger": {
                                                                                        "type": "MessageTrigger",
                                                                                        "keyRaw": "trigger",
                                                                                        "visible": true
                                                                                    },

                                                                                    "important": {
                                                                                        "type": "Boolean",
                                                                                        "keyRaw": "important",
                                                                                        "visible": true
                                                                                    }
                                                                                }
                                                                            },

                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            },

                                                            "locations": {
                                                                "type": "InventoryLocation",
                                                                "keyRaw": "locations",

                                                                "selection": {
                                                                    "fields": {
                                                                        "location": {
                                                                            "type": "Location",
                                                                            "keyRaw": "location",

                                                                            "selection": {
                                                                                "fields": {
                                                                                    "name": {
                                                                                        "type": "String",
                                                                                        "keyRaw": "name",
                                                                                        "visible": true
                                                                                    },

                                                                                    "id": {
                                                                                        "type": "Int",
                                                                                        "keyRaw": "id",
                                                                                        "visible": true,
                                                                                        "nullable": true
                                                                                    }
                                                                                }
                                                                            },

                                                                            "visible": true
                                                                        },

                                                                        "id": {
                                                                            "type": "UInt",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            },

                                                            "store": {
                                                                "type": "Store",
                                                                "keyRaw": "store",

                                                                "selection": {
                                                                    "fields": {
                                                                        "code": {
                                                                            "type": "String",
                                                                            "keyRaw": "code",
                                                                            "visible": true
                                                                        },

                                                                        "id": {
                                                                            "type": "UInt",
                                                                            "keyRaw": "id",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "locations": {
                                                    "type": "DocumentLineLocation",
                                                    "keyRaw": "locations",

                                                    "selection": {
                                                        "fields": {
                                                            "location": {
                                                                "type": "LocationUnion",
                                                                "keyRaw": "location",

                                                                "selection": {
                                                                    "abstractFields": {
                                                                        "fields": {
                                                                            "VirtualLocation": {
                                                                                "name": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "name",
                                                                                    "visible": true
                                                                                },

                                                                                "__typename": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "__typename",
                                                                                    "visible": true
                                                                                }
                                                                            },

                                                                            "Location": {
                                                                                "name": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "name",
                                                                                    "visible": true
                                                                                },

                                                                                "id": {
                                                                                    "type": "Int",
                                                                                    "keyRaw": "id",
                                                                                    "visible": true,
                                                                                    "nullable": true
                                                                                },

                                                                                "__typename": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "__typename",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "typeMap": {}
                                                                    },

                                                                    "fields": {
                                                                        "__typename": {
                                                                            "type": "String",
                                                                            "keyRaw": "__typename",
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "abstract": true,
                                                                "visible": true
                                                            },

                                                            "id": {
                                                                "type": "UInt",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "vehicle": {
                                                    "type": "Vehicle",
                                                    "keyRaw": "vehicle",
                                                    "nullable": true,

                                                    "selection": {
                                                        "fields": {
                                                            "stockNumber": {
                                                                "type": "String",
                                                                "keyRaw": "stockNumber",
                                                                "visible": true
                                                            },

                                                            "taxable": {
                                                                "type": "Boolean",
                                                                "keyRaw": "taxable",
                                                                "visible": true
                                                            },

                                                            "id": {
                                                                "type": "UInt",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "attachments": {
                            "type": "SalesOrderAttachment",
                            "keyRaw": "attachments",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "public": {
                                        "type": "Boolean",
                                        "keyRaw": "public",
                                        "visible": true
                                    },

                                    "rank": {
                                        "type": "Int",
                                        "keyRaw": "rank",
                                        "visible": true
                                    },

                                    "file": {
                                        "type": "File",
                                        "keyRaw": "file",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "Int",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "created": {
                                                    "type": "DateTime",
                                                    "keyRaw": "created",
                                                    "visible": true
                                                },

                                                "extension": {
                                                    "type": "String",
                                                    "keyRaw": "extension",
                                                    "visible": true
                                                },

                                                "mimetype": {
                                                    "type": "String",
                                                    "keyRaw": "mimetype",
                                                    "visible": true
                                                },

                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "hash": {
                                                    "type": "String",
                                                    "keyRaw": "hash",
                                                    "visible": true
                                                },

                                                "type": {
                                                    "type": "FileType",
                                                    "keyRaw": "type",
                                                    "visible": true
                                                },

                                                "updated": {
                                                    "type": "Date",
                                                    "keyRaw": "updated",
                                                    "visible": true
                                                },

                                                "path": {
                                                    "type": "String",
                                                    "keyRaw": "path",
                                                    "visible": true
                                                },

                                                "size": {
                                                    "type": "Int",
                                                    "keyRaw": "size",
                                                    "visible": true
                                                },

                                                "host": {
                                                    "type": "String",
                                                    "keyRaw": "host",
                                                    "visible": true
                                                },

                                                "url": {
                                                    "type": "String",
                                                    "keyRaw": "url",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "adjustments": {
                            "type": "SalesOrderAdjustment",
                            "keyRaw": "adjustments",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "adjustmentType": {
                                        "type": "AdjustmentType",
                                        "keyRaw": "adjustmentType",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "code": {
                                                    "type": "String",
                                                    "keyRaw": "code",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "amount": {
                                        "type": "Decimal2",
                                        "keyRaw": "amount",
                                        "visible": true
                                    },

                                    "date": {
                                        "type": "Date",
                                        "keyRaw": "date",
                                        "visible": true
                                    },

                                    "description": {
                                        "type": "String",
                                        "keyRaw": "description",
                                        "visible": true
                                    },

                                    "subtotalAdjustment": {
                                        "type": "Boolean",
                                        "keyRaw": "subtotalAdjustment",
                                        "visible": true
                                    },

                                    "taxable": {
                                        "type": "Boolean",
                                        "keyRaw": "taxable",
                                        "visible": true
                                    },

                                    "void": {
                                        "type": "Boolean",
                                        "keyRaw": "void",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "appliedPaymentLines": {
                            "type": "PaymentLine",
                            "keyRaw": "appliedPaymentLines",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "amount": {
                                        "type": "Decimal2",
                                        "keyRaw": "amount",
                                        "visible": true
                                    },

                                    "payment": {
                                        "type": "Payment",
                                        "keyRaw": "payment",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "comments": {
                                                    "type": "String",
                                                    "keyRaw": "comments",
                                                    "visible": true
                                                },

                                                "date": {
                                                    "type": "Date",
                                                    "keyRaw": "date",
                                                    "visible": true
                                                },

                                                "dateEntered": {
                                                    "type": "DateTime",
                                                    "keyRaw": "dateEntered",
                                                    "visible": true
                                                },

                                                "documentNumber": {
                                                    "type": "String",
                                                    "keyRaw": "documentNumber",
                                                    "visible": true
                                                },

                                                "paymentMethod": {
                                                    "type": "PaymentMethod",
                                                    "keyRaw": "paymentMethod",

                                                    "selection": {
                                                        "fields": {
                                                            "name": {
                                                                "type": "String",
                                                                "keyRaw": "name",
                                                                "visible": true
                                                            },

                                                            "id": {
                                                                "type": "UInt",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "store": {
                                                    "type": "Store",
                                                    "keyRaw": "store",

                                                    "selection": {
                                                        "fields": {
                                                            "name": {
                                                                "type": "String",
                                                                "keyRaw": "name",
                                                                "visible": true
                                                            },

                                                            "id": {
                                                                "type": "UInt",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "storeId": {
                                                    "type": "UInt",
                                                    "keyRaw": "storeId",
                                                    "visible": true
                                                },

                                                "void": {
                                                    "type": "Boolean",
                                                    "keyRaw": "void",
                                                    "visible": true
                                                },

                                                "createdBy": {
                                                    "type": "UserAccount",
                                                    "keyRaw": "createdBy",

                                                    "selection": {
                                                        "fields": {
                                                            "name": {
                                                                "type": "String",
                                                                "keyRaw": "name",
                                                                "visible": true
                                                            },

                                                            "id": {
                                                                "type": "Int",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "customer": {
                            "type": "Customer",
                            "keyRaw": "customer",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "companyName": {
                                        "type": "String",
                                        "keyRaw": "companyName",
                                        "visible": true
                                    },

                                    "balance": {
                                        "type": "String",
                                        "keyRaw": "balance",
                                        "visible": true
                                    },

                                    "accountLimit": {
                                        "type": "Decimal2",
                                        "keyRaw": "accountLimit",
                                        "visible": true
                                    },

                                    "addresses": {
                                        "type": "CustomerAddress",
                                        "keyRaw": "addresses",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "label": {
                                                    "type": "String",
                                                    "keyRaw": "label",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "messages": {
                                        "type": "Message",
                                        "keyRaw": "messages(filter: $messageFilter)",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "text": {
                                                    "type": "String",
                                                    "keyRaw": "text",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "type": {
                                                    "type": "MessageType",
                                                    "keyRaw": "type",
                                                    "visible": true
                                                },

                                                "trigger": {
                                                    "type": "MessageTrigger",
                                                    "keyRaw": "trigger",
                                                    "visible": true
                                                },

                                                "important": {
                                                    "type": "Boolean",
                                                    "keyRaw": "important",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "billingAddress": {
                            "type": "Address",
                            "keyRaw": "billingAddress",

                            "selection": {
                                "fields": {
                                    "address1": {
                                        "type": "String",
                                        "keyRaw": "address1",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "city": {
                                        "type": "String",
                                        "keyRaw": "city",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "country": {
                                        "type": "String",
                                        "keyRaw": "country",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "state": {
                                        "type": "String",
                                        "keyRaw": "state",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "zip": {
                                        "type": "String",
                                        "keyRaw": "zip",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "company": {
                                        "type": "String",
                                        "keyRaw": "company",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "contact": {
                                        "type": "String",
                                        "keyRaw": "contact",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "phone": {
                                        "type": "String",
                                        "keyRaw": "phone",
                                        "nullable": true,
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "shippingAddress": {
                            "type": "Address",
                            "keyRaw": "shippingAddress",

                            "selection": {
                                "fields": {
                                    "address1": {
                                        "type": "String",
                                        "keyRaw": "address1",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "city": {
                                        "type": "String",
                                        "keyRaw": "city",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "company": {
                                        "type": "String",
                                        "keyRaw": "company",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "contact": {
                                        "type": "String",
                                        "keyRaw": "contact",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "state": {
                                        "type": "String",
                                        "keyRaw": "state",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "zip": {
                                        "type": "String",
                                        "keyRaw": "zip",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "country": {
                                        "type": "String",
                                        "keyRaw": "country",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "phone": {
                                        "type": "String",
                                        "keyRaw": "phone",
                                        "nullable": true,
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "shippingMethod": {
                            "type": "ShippingMethod",
                            "keyRaw": "shippingMethod",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "salesperson": {
                            "type": "UserAccount",
                            "keyRaw": "salesperson",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "Int",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "taxItem": {
                            "type": "TaxItem",
                            "keyRaw": "taxItem",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "term": {
                            "type": "Term",
                            "keyRaw": "term",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true,
                                        "nullable": true
                                    },

                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "visible": true
                                    },

                                    "chargeDays": {
                                        "type": "Int",
                                        "keyRaw": "chargeDays",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "chargeDayOfMonth": {
                                        "type": "Int",
                                        "keyRaw": "chargeDayOfMonth",
                                        "nullable": true,
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "key": "SalesOrderKey",
            "messageFilter": "MessageFilter",
            "pagination": "PaginationOptions"
        },

        "types": {
            "SalesOrderKey": {
                "salesOrderId": "UInt",
                "storeId": "UInt"
            },

            "MessageFilter": {
                "active": "Boolean",
                "display": "MessageDisplay",
                "triggers": "MessageTrigger"
            },

            "PaginationOptions": {
                "pageNumber": "Int",
                "pageSize": "Int"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=91cf85e4abc69867f7cf100aa45ccc4f4b720b3b96b517ed1e7be76990f82fda";